var map;
var toggleableLayerGroups = [
  // [ ['waterrights','Water Rights']],
  // [ ['waterpod','Water POD']],
];
//
// var legendDataWaterRights = [
//   ['80321', '#800000'],
//   ['20350', '#e6194B'],
//   ['22102', '#9A6324'],
//   ['24806', '#f58231'],
//   ['25663', '#ffe119'],
//   ['26193', '#3cb44b'],
//   ['28700', '#42d4f4'],
//   ['11734', '#469990'],
//   ['15157', '#000075'],
//   ['18588', '#4363d8'],
//   ['23960', '#e6beff'],
//   ['23961', '#f032e6'],
//   ['75601', '#a9a9a9']
// ];

//var legendDataWaterPOD = [];

$(document).ready(function(){

  if ($("#homepage").length){

    // Gallery thumbnail resizing (this might be useless)
    // var smallestHeight = 999;
    // $(".homepage-gallery-thumbnail").each(function(){
    //   if ($(this).height() < smallestHeight){
    //     smallestHeight = $(this).height();
    //   }
    // });
    //
    // $(".homepage-gallery-thumbnail").each(function(){
    //   $(this).height(smallestHeight);
    // });


        map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/satellite-streets-v9',
            center: [-96.9863367,43.0269407],
            zoom: 11,
            scrollZoom: false,
        });

        map.on('style.load', function () {
          initializeMapLayers();

        });

        map.on('load', function () {

          // Add zoom and rotation controls to the map.
          map.addControl(new mapboxgl.NavigationControl(), 'top-left');

          // Base Layers
          $(".menubase a").click(function(){
            map.setStyle('mapbox://styles/mapbox/' + $(this).attr('data-layer'));
            $(this).siblings().each(function( index ){
              $(this).removeClass('active');
            });
            $(this).addClass('active');

          });


          // Set up toggles
          for (var g = 0; g < toggleableLayerGroups.length; g++) {

            var menu = $("<div></div>").addClass("menu menulayers");

            for (var i = 0; i < toggleableLayerGroups[g].length; i++) {

              var id = toggleableLayerGroups[g][i][0];

              var link = $("<a class='' data-layer='"+toggleableLayerGroups[g][i][0]+"'>"+toggleableLayerGroups[g][i][1]+"</a>");

              link.click(function(e){

                e.preventDefault();
                e.stopPropagation();

                if ($(this).hasClass('active')){
                  $(this).removeClass('active');

                }else{
                  // get siblings
                  $(this).siblings().each(function( index ){

                    $(this).removeClass('active');

                  });

                  $(this).addClass('active');
                }



                toggleMapLayers();

              });

              menu.append(link);
              $("#menus").append(menu);

            }
          }

          initializeMapLegends();

        });

  }

});


function initializeMapLayers(){

    //
    // // Aspect
    // if (!map.getSource("aspect")) {
    //   map.addSource('aspect', {
    //       'type': 'geojson',
    //       data: aspectURL
    //   });
    // }
    // map.addLayer({
    //     'id': 'aspect',
    //     'type': 'fill',
    //     'source': 'aspect',
    //     'layout': {
    //       'visibility': 'none'
    //     },
    //     "paint": {
    //       'fill-color': {
    //        property: 'aspect',
    //        'type': 'categorical',
    //        stops: legendDataAspect
    //      },
    //      'fill-opacity':0.9
    //     }
    //
    // });
    //
    // // Slope
    // if (!map.getSource("slope")) {
    //   map.addSource('slope', {
    //       'type': 'geojson',
    //       data: slopeURL
    //   });
    // }
    // map.addLayer({
    //     'id': 'slope',
    //     'type': 'fill',
    //     'source': 'slope',
    //     'layout': {
    //       'visibility': 'none'
    //     },
    //     "paint": {
    //       'fill-color': {
    //        property: 'pct_slope',
    //        'type': 'categorical',
    //        stops: legendDataSlope
    //      },
    //      'fill-opacity':0.9
    //     }
    //
    // });
    //
    // Water Rights
    // if (!map.getSource("waterrights")) {
    //   map.addSource('waterrights', {
    //       'type': 'geojson',
    //       data: waterRightsURL
    //   });
    // }
    // map.addLayer({
    //     'id': 'waterrights',
    //     'type': 'fill',
    //     'source': 'waterrights',
    //     'layout': {
    //       'visibility': 'none'
    //     },
    //     "paint": {
    //       'fill-color': {
    //        property: 'WR_ID',
    //        'type': 'categorical',
    //        stops: legendDataWaterRights
    //      },
    //      'fill-opacity':0.9
    //     }
    //
    // });

    // Water POD
    // if (!map.getSource("waterpod")) {
    //   map.addSource('waterpod', {
    //       'type': 'geojson',
    //       data: waterPODURL
    //   });
    // }
    // map.addLayer({
    //     'id': 'waterpod',
    //     'type': 'symbol',
    //     'source': 'waterpod',
    //     'layout': {
    //       'icon-image': 'marker-15',
    //       'icon-size': 2,
    //       'visibility': 'none'
    //     },
    //     "paint": {
    //         "icon-color": "#ffffff",
    //         "icon-halo-color": "rgba(0, 0, 0, 1)",
    //         "icon-halo-width": 20,
    //
    //     }
    // });
    //
    // // Contours 20
    // if (!map.getSource("contours20")) {
    //   map.addSource('contours20', {
    //       'type': 'geojson',
    //       data: contours20URL
    //   });
    // }
    // var aspectLayer = map.addLayer({
    //     'id': 'contours20',
    //     'type': 'line',
    //     'source': 'contours20',
    //     'layout': {
    //       'visibility': 'none'
    //     },
    //     "paint": {
    //         "line-color": "#efefef",
    //         "line-width": 1
    //     }
    // });
    //
    //
    // Property Boundary
    if (!map.getSource("property")) {
      map.addSource("property", {
           "type": "geojson",
           data: propertyURL,
       });
    }
    map.addLayer({
        "id": "property",
        "type": "line",
        "source": "property",
        "layout": {},
        "paint": {
            "line-color": "#e23e21",
            "line-width": 4
        }
    });


    toggleMapLayers();
}

function initializeMapLegends(){

    // // Aspect
    // var tempLegend = "<div id='legend-aspect' class='legend'><h6>Aspect</h6>";
    // for (var i = 0; i < legendDataAspect.length; i++) {
    //   tempLegend += "<div><span style='background-color: "+legendDataAspect[i][1]+"'></span>"+legendDataAspect[i][0]+"</div>";
    // }
    // tempLegend += "</div>";
    // //console.log(tempLegend);
    // $("#legends").append(tempLegend);
    //
    // // Slope
    // var tempLegend = "<div id='legend-slope' class='legend'><h6>Slope</h6>";
    // for (var i = 0; i < legendDataSlope.length; i++) {
    //   tempLegend += "<div><span style='background-color: "+legendDataSlope[i][1]+"'></span>"+legendDataSlope[i][0]+"</div>";
    // }
    // tempLegend += "</div>";
    // //console.log(tempLegend);
    // $("#legends").append(tempLegend);
    //
    // Water Rights
    var tempLegend = '';
    // var tempLegend = "<div id='legend-waterrights' class='legend'><h6>Water Rights</h6>";
    // for (var i = 0; i < legendDataWaterRights.length; i++) {
    //   tempLegend += "<div><span style='background-color: "+legendDataWaterRights[i][1]+"'></span>"+legendDataWaterRights[i][0]+"</div>";
    // }
    // tempLegend += "</div>";
    //console.log(tempLegend);
    $("#legends").append(tempLegend);

}

function toggleMapLayers(){

  $(".menulayers").each(function(){

    $(this).children('a').each(function(){

      var thisLayerID = $(this).attr('data-layer');

      var visibility = map.getLayoutProperty(thisLayerID, 'visibility');

      if ($(this).hasClass('active') && visibility !== 'visible') {
          map.setLayoutProperty(thisLayerID, 'visibility', 'visible');

          $("#legend-"+thisLayerID).show();

      } else if (!$(this).hasClass('active') && visibility === 'visible') {

          map.setLayoutProperty(thisLayerID, 'visibility', 'none');

          // Legends Check
          $("#legend-"+thisLayerID).hide();

      }


    });

  });

}



// WEBPACK FOOTER //
// ./resources/assets/js/public/home.js